__turbopack_context__.v({
  "checkIcon": "Tab-module-scss-module__OxSTCW__checkIcon",
  "closeIcon": "Tab-module-scss-module__OxSTCW__closeIcon",
  "fade-in": "Tab-module-scss-module__OxSTCW__fade-in",
  "isActive": "Tab-module-scss-module__OxSTCW__isActive",
  "isDisabled": "Tab-module-scss-module__OxSTCW__isDisabled",
  "isToggle": "Tab-module-scss-module__OxSTCW__isToggle",
  "label": "Tab-module-scss-module__OxSTCW__label",
  "root": "Tab-module-scss-module__OxSTCW__root",
});
